import DeliveryInformationCard from "../../../ShoppingCart/CartDetailsView/DeliveryInformationCard";
import { decorateTimeline, orderTrackState } from "../order-detail-utils";
import OrderHistoryBox from "./OrderHistoryBox";
import ReviewButtonCard from "./ReviewButtonCard";
import { getLabel } from "../../../../../hooks/use-labels";
import { formatMoney } from "../../../../../features/orders/format";

const EtaLine = ({ scheduled, label }) => {
  if (!label) return null;

  return (
    <p className="ord-eta">
      <span className="ord-eta-label">
        {scheduled ? "Delivery Date" : "Expected Delivery"}
      </span>
      <span className="ord-eta-value">{label}</span>
    </p>
  );
};

const MasterDeliveryCard = ({ aggregate, total }) => (
  <section className="ord-panel">
    <h2 className="ord-panel-title">
      {aggregate?.deliveryTypeLabel
        ? getLabel(aggregate.deliveryTypeCode) || aggregate.deliveryTypeLabel
        : "Delivery per supplier"}
    </h2>

    {aggregate?.addressLabel && (
      <p className="ord-delivery-address">{aggregate.addressLabel}</p>
    )}

    <EtaLine scheduled={aggregate?.scheduled} label={aggregate?.etaLabel} />

    <div className="ord-receipt-rule" />

    <div className="ord-receipt-total">
      <span>{getLabel("totalLabel") || "Total"}</span>
      <span>{formatMoney(total)}</span>
    </div>
  </section>
);

const OrderSideDetail = ({
  detail,
  isMaster,
  aggregate,
  masterTotal,
  actions,
}) => {
  const timeline = decorateTimeline(
    isMaster ? aggregate?.timeline : detail?.timeline
  );

  return (
    <div className="ord-side">
      {isMaster ? (
        <MasterDeliveryCard aggregate={aggregate} total={masterTotal} />
      ) : (
        <section className="ord-panel">
          <DeliveryInformationCard
            borderless={true}
            detail={detail}
            titleClass="ord-panel-title"
            titleStyle={{ color: "#fff" }}
          />

          <EtaLine scheduled={detail.scheduled} label={detail.deliveryLabel} />
        </section>
      )}

      <OrderHistoryBox
        timeline={timeline}
        state={orderTrackState(timeline)}
        footer={actions}
      />

      {!isMaster && detail.ratable && (
        <ReviewButtonCard supplier={detail.supplier} />
      )}
    </div>
  );
};

export default OrderSideDetail;
